import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class PayvendService extends HeaderService {

    getPayvendsByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getVPosByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createPayvend(Payvend: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'vPos/',
            JSON.stringify(Payvend),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updatePayvend(Payvend: any, id: String): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'vPos/' + id,
            JSON.stringify(Payvend),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getPayvendById(id: String): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'vPos/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deletePayvend(_id: any): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'vPos/' + _id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getvPosesForSuperAdmin(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'vPoses-for-super-admin/',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/payvend.service.ts